<template>
	<div ref="view" id="overlays" class="shadow-dk">
		<div class="mini-left-col category">
			<div class="legend-header">
				OVERLAYS
			</div>
			<div class="legend-list">
				<div v-for="(row, index) in categories" :key="row.label" class="legend-row">
					<span class="legend-swatch" :style="swatchStyle(row)">
					</span>
					<span class="legend-label">
						{{row.label}}
					</span>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

const millsecondsIsNew = 1000*60*60*24*90;
const categories = [
	{label:'aviation',color:'#80D4FA'},
	{label:'ecological',color:'#66BB69'},
	{label:'transportation',color:'#7D57C2'},
	{label:'historical',color:'#8D6E62'},
	{label:'hazard',color:'#FF8A65'},
	{label:'regulatory',color:'#FFF176'}
];

export default {
	name: 'permit-list',
	components:{},
	created:function(){
		let foo = 3;
	},
	data: function(){
		return {
			tabActive:'overview',
			permitHighlight:null,
			categories
		}
	},
	computed: {
		overlays: function(){
			return this.$store.state.search.results;
		},
		searchType:function(){
			return this.$store.state.search.type;
		},
		poiHighlight: function(){
			return this.$store.state.map.poiHighlight;
		},
		poiClick: function(){
			return this.$store.state.map.poiClick;
		},
		mapLoaded: function(){
			return this.$store.state.map.loaded;
		}
	},
	methods: {
		swatchStyle:function(row){
			return 'background-color:'+row.color+';';
		},
		jurisdictionPermitURL: function(permitId){
			//	TODO: make this dynamic for all jurisdictions
			return 'https://opendsd.sandiego.gov/Web/Approvals/Details/'+permitId;
		},
		parcelURL: function(id){
			if (!id){
				return false;
			}
			return "/parcels/"+id;
		},
		parcelGo:function(e,parcelId){
			const route = {
				name: 'parcels', 
				params:{
					id: parcelId
				}
			};
			this.$router.push(route);
			e.stopPropagation();
			return false;
		},
		formatDate: function(dateStr){ //	pass in dateString, outputs MM/DD/YYYY format
			if (!dateStr){
				return ""
			}
			var d = new Date(dateStr);
			//	sniffing for invalid dates
			if (d.getUTCFullYear() == 1){
				return ""
			}
			//	format our datestring
			return (d.getUTCMonth()+1) +"/"+ d.getUTCDate() + "/" + d.getUTCFullYear();
		},
		validDate:function(dateStr){
			try{
				var d = new Date(dateStr);
				if (d.getUTCFullYear() == 1){
					return false;
				}
				return true;
			} catch(e){
				return false;
			}
		},
		isNew: function(dateStr){ //	check if a date is new
			if (!dateStr){
				return ""
			}
			let d = new Date(dateStr);
			let today = new Date();

			//	get date diff to determine "new"
			if ((today - d) < millsecondsIsNew){
				return true;
			}
			return false;
		},
		mouseenter: function(e, permit){
			let title;
			if (permit.parcelId){
				title = '<a href="/parcels/'+permit.parcelId+'" target="_blank">'+permit.typeRaw+'</a>';
			} else {
				title = permit.typeRaw;
			}

			const obj = {
				properties:{
					permitId:permit.id,
					parcelId:permit.parcelId,
					resource_id:permit.id,
					route:{
						name: 'permit', 
						params:{
							id:permit.id
						}
					}
				},
				geometry:{
					type: "Point",
					coordinates: [permit.geom.lon, permit.geom.lat]
				}
			};
			this.$store.dispatch('MAP_POI_HOVER_SET', [obj]);	
		},
		click: function(e, permit){
			const route = {
				name: 'permit', 
				params:{
					id: permit.id
				}
			};
			this.$router.push(route);
		},
		mouseleave: function(e, permit){
			this.$store.dispatch('MAP_POI_HOVER_SET', null);	
		},
		getStatus:function(permit){
			if (this.validDate(permit.completedDate)){
				return 'Completed';
			}
			if (this.validDate(permit.issuedDate)){
				return 'Issued';
			}
			if (this.validDate(permit.appliedDate)){
				return 'Applied';
			}
		},
		getStatusLast:function(permit){
			if (this.validDate(permit.completedDate)){
				return permit.completedDate;
			}
			if (this.validDate(permit.issuedDate)){
				return permit.issuedDate;
			}
			if (this.validDate(permit.appliedDate)){
				return permit.appliedDate;
			}
		},
		getStatusDate:function(permit){
			return this.formatDate(this.getStatusLast(permit));
		},
		getStatusIsNew:function(permit){
			return this.isNew(this.getStatusLast(permit));
		},
		getHighlightClass:function(permit){
			return (permit.id === this.permitHighlight)? 'highlight': '';
		},
		overlaysPoi:function(){
			if (!this.mapLoaded || !this.overlays) return;
			// clear poi active
			let poi = [];
			this.overlays.map((permit)=>{

				let description = permit.number+' permit'+((permit.number > 1)? 's':'');
				let title;
				//	build our title link if we have a parcelId. not all overlays have an APN (i.e. right of way grading)
				if (permit.parcelId){
					title = '<a href="/parcels/'+permit.parcelId+'" target="_blank">'+permit.typeRaw+'</a>';
				} else {
					title = permit.typeRaw;
				}
				//	build our geojson for the point and add it to our features array
				poi.push({
					type: "Feature",
					geometry: {
						type: "Point",
						coordinates: [permit.geom.lon, permit.geom.lat]
					},
					properties: {
						description:description,
						permitId:permit.id,
						parcelId:permit.parcelId,
						route:{
							name: 'permit', 
							params:{
								id:permit.id
							}
						}
					}
				});
			});

			this.$store.dispatch('MAP_POI_SET', {
				poi: poi
			});		

			this.$store.dispatch('MAP_POI_ACTIVE', {
				poi:[]
			});		
		},
		updateTitleTag:function(){
			if (!this.overlays) return document.title = 'Permits - Scoutred Maps';
			document.title = this.overlays.length+' overlays - Scoutred Maps';
		}
	},

	watch:{
		overlays:function(){
			this.updateTitleTag();
		},
		poiHighlight:function(newPoi){
			if (!newPoi){
				this.$data.permitHighlight = null;
				return;
			}
			this.$data.permitHighlight = newPoi.properties.permitId;
		}
	}
}

</script>

<style>

#overlays .font-10{font-size:10px;}

#overlays h5{
	font-size:14px;
	line-height:18px;
}
#overlays .field-row{
	font-size:14px;
	line-height:24px;
}
#overlays .card{
	cursor:pointer;
	background-color:rgba(255,255,255,0.9);
}
#overlays .highlight,#overlays .card:hover{
	background-color:rgba(255,255,255,1);
}

.table-text-sm{
	font-size:0.85em;
}
.legend-row{
	line-height:15px;
}
.legend-label{
	font-size:10px;
	line-height:14px;
	vertical-align:middle;
}
.legend-list{
	padding:0.1rem 0.25rem;
}
.legend-group{
}
.legend-group.off{
	background-color:#CFD8DD;
}
.legend-group.off i{
	color:#8FA3AE;
}

.legend-header{
	cursor:pointer;
	border-bottom:1px solid #EEE;
	padding:0 .25rem;
	font-size:11px;
}
.legend-group.off .legend-header:hover{
	background-color:#EDEFF1;
}
.legend-group.off .legend-header:hover i{
	color:#788F9C;
}

.legend-group.off .legend-header{
	border-bottom:none;
}

.legend-swatch{
	width:12px;
	height:12px;
	display:inline-block;
	vertical-align:middle;
	margin-right:2px;
}

</style>


// WEBPACK FOOTER //
// src/components/overlay/overlay-list.vue